import { createStore } from 'redux';
import reducers from './reducers';

function store(token) {
  const surveyStorageKey = `BRM_SECA_SURVEY_ANSWERS/${token}`;
  const storedAnswers = sessionStorage.getItem(surveyStorageKey);
  const initialAnswers = storedAnswers && JSON.parse(storedAnswers);

  const initialState = {
    questions: {
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      2: [
        18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32,
        33, 34, 35, 36, 37, 38, 39, 40,
      ],
    },
    answers: initialAnswers || {},
  };

  const store = createStore(reducers, initialState);

  store.subscribe(()=>{
    sessionStorage.setItem(surveyStorageKey, JSON.stringify(store.getState().answers))
  });

  return store;
}

export default store;
